// 扩展卡片功能菜单
export enum CardMenuType {
    /** 尺寸调整 */
    ADJUST_SIZE_CHANGE = 'adjust_size',
    /** 消除笔 */
    ADJUST_ELIMINATE = 'adjust_eliminate_pen',
    /** AI 消除笔 */
    ADJUST_AI_ELIMINATE = 'adjust_ai_eliminate_pen',
    /** 变清晰 */
    ADJUST_AI_QUALITY = 'adjust_ai_quality',
    // 智能抠图
    ADJUST_AI_MATTING = 'adjust_ai_matting',
    // 商品精修
    ADJUST_AI_PRODUCT_RETOUCHING = 'adjust_ai_product_retouching',
}

// 元素菜单tab
export enum TabEnum {
    /** 素材 */
    MATERIAL_MENU = 'menuCustomMaterial',
    /** 照片 */
    PHOTO_MENU = 'menuPhoto',
    /** 背景 */
    BACKGROUND_MENU = 'menuBackground',
}

// mog菜单类型
export enum MogCollapseType {
    // 预设
    PRESET = 'C_PRESET',
    // 基础调色
    BASIC_MOG = 'C_BASIC_MOG',
    // 高级调色
    ADVANCED_MOG = 'C_ADVANCED_MOG',
    // 一键换色
    INTELLIGENT = 'C_INTELLIGENT',
    // 滤镜
    FILTER = 'C_FILTER',
}

// 扩展卡片功能菜单
export enum MogMenuType {
    /** 预设 */
    MOG_PRESET = 'mog_preset',
    /** 一键换色 */
    MOG_INTELLIGENT = 'mog_intelligent',
    /** 基础调色 */
    MOG_BASE = 'mog_base',
    /** 光效 */
    MOG_LIGHT = 'mog_light',
    /** 色彩 */
    MOG_COLOR = 'mog_color',
    /** 色调分离 */
    MOG_POSTERIZE = 'mog_posterize',
    /** hsl */
    MOG_HSL = 'mog_hsl',
    /** 细节 */
    MOG_PARTICULARS = 'mog_particulars',
    /** 滤镜 */
    MOG_FILTER = 'mog_filter',
}
